import { Grid, IconButton, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import Item from "../atoms/Item";
import { useReactiveVar } from "@apollo/client";
import { cartItemsVar, referenceNoVar, totalVar } from "../../graphql/reactiveVars";
import { useAnalytics } from "../../analytics";
import PageTimer from "../../analytics/PageTimer";
import metapixelEvents from "../../analytics/metapixelEvents";
import { CloseIcon } from "../../assets/icon";
import ProductDisplay from "../organisms/ProductDisplay";
import { CURRENT_SCREEN_NAME } from "../../analytics/useAnalytics";
import { clearData } from "../../graphql/actions/uiActions";

const calculateOrderDetails = (products) => {
  let totalNumberOfItems = 0;
  let totalAmount = 0;

  if (products.length <= 0) {
    return { totalNumberOfItems, totalAmount: totalAmount.toFixed(2) };
  }

  products.forEach((p) => {
    totalNumberOfItems += p.qty;
    totalAmount += p.qty * p.price;
  });

  return { totalNumberOfItems, totalAmount: totalAmount.toFixed(2) };
};

const OrderStatusPage = ({ distributor }) => {
  const navigate = useNavigate();
  const totalCost = useReactiveVar(totalVar);
  const cartItems = useReactiveVar(cartItemsVar);
  const orderRef = sessionStorage.getItem("referenceNo");

  const { fireViewScreenEvent } = useAnalytics();

  useEffect(() => {
    fireViewScreenEvent(CURRENT_SCREEN_NAME.menu_order_confirmation);
    // if (!orderRef) return navigate("/confirm-order");
    referenceNoVar(orderRef);
    // fireViewScreenEvent(PageLabels.ORDER_RECEIVED);
    metapixelEvents.metapixelPurchase(totalCost);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { totalNumberOfItems, totalAmount } = calculateOrderDetails(cartItems);

  return (
    <>
      <Stack sx={{ minWidth: "100vw" }} justifyContent="center" alignItems="center" spacing={0.5}>
        <Grid container justifyContent="center">
          <Item
            sx={{ width: "100%", bgcolor: "#DFF2EE", paddingTop: 5, paddingBottom: 1 }}
            container
            justifyContent="center"
          >
            <Item sx={{ position: "absolute", left: 8, top: 8 }}>
              <IconButton
                onClick={() => {
                  clearData();
                  navigate(`/${distributor}/products`);
                }}
              >
                <CloseIcon size="36" />
              </IconButton>
            </Item>

            <Item style={{ width: "100%", textAlign: "center" }}>
              <svg width="196" height="124" viewBox="0 0 196 124" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1846_8552)">
                  <path
                    d="M97.7693 72.4361L164 20.9711H123.358L97.7693 72.4361ZM97.7693 72.4361L121.746 123.901H160.631L97.7693 72.4361ZM195.503 51.3985L97.7334 72.4361L195.503 96.0541V51.3985ZM97.7693 72.4361L31.5385 123.901H72.1801L97.7693 72.4361ZM34.8715 20.9711L97.7693 72.4361L73.7929 20.9711H34.8715ZM97.7693 72.4361L0 48.8181V93.4378L97.7693 72.4361Z"
                    fill="#4CB896"
                  />
                  <path
                    d="M97.7691 72.4361L123.358 20.9711H73.7927L97.7691 72.4361ZM146.546 61.9353L195.538 51.3985V37.0628C195.538 28.1747 188.335 20.9711 179.447 20.9711H164L97.7691 72.4361L146.009 62.0786C144.826 69.3181 141.744 76.1634 137.264 82.0052L97.7691 72.4719L123.896 93.8321C119.559 96.4125 115.008 98.2761 110.349 99.423L97.7691 72.4361L84.5086 99.1363C79.7062 97.8461 75.1187 95.8749 70.9255 93.3303L97.7691 72.4719L57.5217 81.1092C53.2927 75.3391 50.3897 68.4938 49.3503 60.7525L97.7691 72.4361L34.8713 20.9711H16.1274C7.23933 20.9711 0.0356445 28.1747 0.0356445 37.0628V48.8181L48.9919 60.645V61.7202C48.9561 68.9239 50.7481 75.7691 53.9378 81.8618L0.0356445 93.4378V107.774C0.0356445 116.662 7.23933 123.865 16.1274 123.865H31.5741L66.4098 96.8068C70.8897 100.355 76.0147 103.114 81.6056 104.978L72.2158 123.865H121.781L113.108 105.265C118.592 103.544 123.788 100.928 128.376 97.4518L160.667 123.865H179.411C188.299 123.865 195.503 116.662 195.503 107.774V96.0182L141.063 82.8653C143.213 78.9588 144.826 74.7657 145.686 70.3575C146.295 67.8129 146.51 64.8741 146.546 61.9353Z"
                    fill="#007358"
                  />
                  <path
                    d="M97.769 9.53845C124.72 9.53845 146.582 30.0743 146.582 55.3767C146.582 80.6792 124.72 101.251 97.769 101.251C70.818 101.251 48.9561 80.715 48.9561 55.3767C48.9561 30.0384 70.818 9.53845 97.769 9.53845Z"
                    fill="white"
                  />
                  <path
                    d="M92.7518 84.4064C85.8707 80.3924 78.2728 75.6616 69.1338 69.8557C66.3742 68.0995 63.8296 65.4833 64.4747 61.7561C65.1198 58.0288 68.417 56.8102 71.7142 58.7814C79.2046 63.333 85.7631 67.347 91.6408 70.895C100.17 59.6416 108.7 50.0008 120.921 42.9405C123.932 41.1844 128.914 41.8295 131.386 43.9798C133.859 46.1302 132.82 49.0332 129.738 50.7535C114.255 59.4265 104.65 70.1424 92.7518 84.4064Z"
                    fill="#007358"
                  />
                  <path
                    d="M91.9632 79.6757C85.0821 75.6617 77.4842 70.9309 68.3452 65.1249C65.5856 63.3688 63.041 60.7526 63.6861 57.0254C64.3312 53.2981 67.6285 52.0795 70.9257 54.0507C78.4161 58.6023 84.9746 62.6163 90.8522 66.1643C99.382 54.9108 107.912 45.2701 120.133 38.2098C123.143 36.4537 128.125 37.0987 130.598 39.2491C133.071 41.3994 132.031 44.3024 128.949 46.0227C113.431 54.6957 103.826 65.4117 91.9632 79.6757Z"
                    fill="#4CB896"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1846_8552">
                    <rect width="195.538" height="124" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </Item>

            <Item className="tx700 tx125 c2" pt={2} style={{ width: "100%", textAlign: "center" }}>
              Order Received!
            </Item>

            <Item
              px={2}
              py={1.5}
              textAlign="center"
              className="tx300 ls75"
              sx={{ fontSize: "15px", color: "#000", maxWidth: 800, width: "100%" }}
            >
              Salamat sa iyong order mula sa <b>Distributor Name</b>! Makikipag-ugnayan siya sa iyo para sa mga detalye
              ng iyong order.
            </Item>

            <Item
              container
              justifyContent="space-between"
              sx={{
                backgroundColor: "#FFFFFF",
                border: "1px solid #D9DBE9",
                borderRadius: "12px",
                mx: 2,
                my: 1,
                p: 0.5,
              }}
            >
              <Item px={2} py={1} sx={{ color: "#6E7191", fontSize: 16, fontWeight: 400 }}>
                Total
              </Item>
              <Item px={2} py={1} sx={{ fontSize: 16, fontWeight: 600 }}>
                ₱{totalAmount}
              </Item>
            </Item>
          </Item>
        </Grid>

        <PageTimer />
      </Stack>

      <Grid container justifyContent="center">
        <Item sx={{ minWidth: "100vw" }} style={{ display: "flex", flexDirection: "column" }}>
          <Item px={2} py={1} m={0.5} sx={{ fontSize: 13, letterSpacing: "0.25px" }}>
            <b>Your order</b> ({totalNumberOfItems} items)
          </Item>

          <Stack spacing={0.75} className="bg_gray">
            {cartItems.map((item) => (
              <ProductDisplay key={item.id} product={item} />
            ))}
          </Stack>
        </Item>
      </Grid>
    </>
  );
};

// const ItemInfo = ({ label, description }) => (
//   <Grid container justifyContent="space-between">
//     <Item className="ls75 c3" sx={{ fontSize: "15.5px", maxWidth: "50%" }}>
//       {label}
//     </Item>
//     <Item className="tx95 c4" sx={{ letterSpacing: "0.5px" }}>
//       {description}
//     </Item>
//   </Grid>
// );

export default OrderStatusPage;
